import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "../../plugins/http";

const SUPPORTED_MENU_PATHS = new Set([
  "/account",
  "/finance",
  "/order",
  "/addOrder",
  "/productPic",
  "/skuCodeCompress",
  "/skuCodeReplace",
  "/stopArea",
  "/skuCodeExtra",
  "/batchAddOrder",
]);

const MENU_ORDER: Record<string, number> = {
  "/account": 1,
  "/finance": 2,
  "/order": 3,
  "/addOrder": 4,
  "/productPic": 5,
  "/skuCodeCompress": 6,
  "/skuCodeReplace": 7,
  "/stopArea": 8,
  "/skuCodeExtra": 9,
  "/batchAddOrder": 10,
};

const getMenuOrder = (path: string) => {
  return MENU_ORDER[path] || Number.MAX_SAFE_INTEGER;
};

const filterMenusBySupportedRoutes = (menus: any[] = []) => {
  return menus
    .map((menu) => {
      const children = (menu.children || []).filter((child: any) =>
        SUPPORTED_MENU_PATHS.has(child.path)
      );
      return {
        ...menu,
        children: children.sort((a: any, b: any) => {
          return getMenuOrder(a.path) - getMenuOrder(b.path);
        }),
      };
    })
    .sort((a: any, b: any) => {
      return getMenuOrder(a.children[0]?.path) - getMenuOrder(b.children[0]?.path);
    })
    .filter((menu) => menu.children.length > 0);
};

const timeRange = (startTime: any, endTime: any) => {
  let startStr = startTime.split(":");
  if (startStr.length != 2) {
    return false;
  }
  let endStr = endTime.split(":");
  if (endStr.length != 2) {
    return false;
  }
  let b = new Date();
  let e = new Date();
  let n = new Date();
  b.setHours(startStr[0]);
  b.setMinutes(startStr[1]);

  e.setHours(endStr[0]);
  e.setMinutes(endStr[1]);

  if (n.getTime() - b.getTime() > 0 && n.getTime() - e.getTime() < 0) {
    return true;
  } else {
    return false;
  }
};
@Component
export default class Index extends Vue {
  breadList: string[] = [];
  isClose: boolean = true;
  menuList: any[] = [];
  visible: boolean = false;
  operator: string = localStorage.getItem("operator") || "";
  checkOperator: string = "";
  checkPassword: string = "";
  userName: any = localStorage.getItem("OPEN_ADMIN_USERNAME") || "";
  isTimeRange: any = true;
  startTime: string = "";
  endTime: string = "";
  shopList: any = [];
  shopId: string = "";
  created() {
    if (!localStorage.getItem("OPEN_ADMIN_SHOPID")) {
      window.localStorage.clear();
      this.$router.push({ path: "/" });
      return;
    }
    this.shopId = localStorage.getItem("OPEN_ADMIN_SHOPID") || "";
    this.getShopList();
    this.getMenus();
    this.getBreadList();
    this.getDetailInfo();
    if (localStorage.getItem("OPEN_ADMIN_WORK_TIME")) {
      let wordTime = localStorage.getItem("OPEN_ADMIN_WORK_TIME");
      this.startTime = wordTime.split("-")[0];
      this.endTime = wordTime.split("-")[1];
      this.isTimeRange = timeRange(this.startTime, this.endTime);
      setInterval(() => {
        this.isTimeRange = timeRange(this.startTime, this.endTime);
      }, 60000);
    }
  }
  @Watch("$route")
  getBreadList() {
    this.breadList = [];
    for (const routeInfo of this.$route.matched) {
      if (typeof routeInfo.meta.name === "string") {
        this.breadList.push(routeInfo.meta.name);
      }
    }
  }
  getShopList() {
    Axios.getSecret("/admin/shop/bind/list").then((res: any) => {
      if (res.data.status === 200) {
        this.shopList = res.data.data || [];
      } else {
        this.$message.error(res.data.msg);
      }
    });
  }
  onChangeShop(id: any) {
    let shopData = this.shopList.filter((item: any) => {
      return item.id == id;
    });

    this.$confirm(`确定切换到${shopData[0].shopName}吗？`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        let data = {
          shopId: id,
        };
        Axios.postByJson("/admin/shop/manage", data).then((res: any) => {
          if (res.data.status === 200) {
            window.localStorage.setItem("OPEN_ADMIN_SHOPID", id);
            this.getDetailInfo();
            this.$router.push({ path: "/admin" });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      })
      .catch(() => {
        this.shopId = localStorage.getItem("OPEN_ADMIN_SHOPID") || "";
      });
  }
  onClose() {
    this.isClose = !this.isClose;
  }
  onLogout() {
    this.$api.logout().then((res) => {
      if (res.data.status == 200) {
        this.$message({
          type: "success",
          message: "退出成功",
        });
        window.localStorage.clear();
        this.$router.push({ path: "/" });
      } else {
        this.$message.error(res.data.msg);
      }
    });
  }

  getMenus() {
    Axios.getSecret(`/api/user/menu`).then((res) => {
      if (res.data.status === 200) {
        // 两套后台共用菜单接口时，前端只展示当前系统已实现的路由菜单。
        this.menuList = filterMenusBySupportedRoutes(res.data.data || []);
      } else {
        this.$message(res.data.msg);
      }
    });
  }

  async getDetailInfo() {
    await Axios.getSecret(`/api/user/my_info`).then((res) => {
      if (res.data.status === 200) {
        window.info = res.data.data || {};
      } else {
        this.$message(res.data.msg);
      }
    });
  }

  setOperator() {
    this.visible = true;
    this.operator = localStorage.getItem("operator") || "";
    this.checkOperator = this.operator;
    this.checkPassword = "";
  }
  saveOperator() {
    if (this.checkPassword === "445727047*3963067362.") {
      localStorage.setItem("operator", this.checkOperator);
      this.operator = this.checkOperator;
      this.visible = false;
    } else {
      this.$message.error("密码错误");
    }
  }
  onHelp() {
    let env = process.env.OPEN_ADMIN_ENV;
    if (env === "production") {
      window.open("https://xx.prprp.com/course/open");
    } else {
      window.open("http://172.16.0.3:88/course/open");
    }
  }
}
